import { type Profile } from 'app/network/profile';
import { SharingPlaceCard } from 'app/components/sharing-place-card';
import { Column } from 'app/design/primitives/box';
import { theme } from './shared';
import { ProfileListingEmpty } from './profile-listing-empty';

export function FrequentedPlaces({ places }: { places: Profile['frequentedPlaces'] }) {
  if (!places?.length) return <ProfileListingEmpty translationKey="place.noFrequentedPlaces" />;
  return (
    <Column
      style={{
        gap: theme.spacing['spacing.general.x2'],
        paddingHorizontal: theme.spacing['spacing.general.x5'],
      }}
    >
      {places.map((place) => (
        <SharingPlaceCard key={place.id} place={place} />
      ))}
    </Column>
  );
}
